import {
  Component, ComponentFactoryResolver, EventEmitter, Input,
  OnChanges, OnDestroy, OnInit, Output, ViewChild, ViewContainerRef
} from '@angular/core';
import { SelectionModel } from '@angular/cdk/collections';
import { BehaviorSubject, Subscription } from 'rxjs';
import { CustomSelection, FilterFields, RowActions, SelectionAction, TotalObject } from '../../../dashboard/admin/report/report';
import { BaseRequestService } from '../../services/base-request.service';

@Component({
  selector: 'app-base-report',
  templateUrl: './base-report.component.html',
  styleUrls: ['./base-report.component.scss']
})

export class BaseReportComponent implements OnInit, OnChanges, OnDestroy {
  @ViewChild("content", { read: ViewContainerRef })

  public filterOpened = new BehaviorSubject<boolean>(false);
  // outputEvents
  @Output() searchChange = new EventEmitter<any>();
  @Output() paginationChange = new EventEmitter<any>();
  @Output() selectionActionTrigger = new EventEmitter<any>();
  @Output() filterTrigger = new EventEmitter<any>();
  @Output() assignedBusinessesFilterChanged = new EventEmitter<boolean>();
  @Output() rowActionClicked = new EventEmitter();
  @Output() sortTrigger = new EventEmitter();
  @Output() ExtpendableRowClicke = new EventEmitter();
  @Output() ExtpendableColumnClick = new EventEmitter();
  // input(value: any)s
  @Input() columnTypes: any;
  @Input() hasCheckboxes: boolean = false;
  @Input() hasAssignedBusinessesFilter: boolean = false;
  @Input() selectionActions: Array<SelectionAction> = [];
  @Input() reportName: string = '';
  @Input() defaultColumns: Array<string> = [];
  @Input() columnsDisplayNames: Object = {};
  @Input() data!: Array<any>;
  @Input() rowsLength: number = 0;
  @Input() filterFields: FilterFields[] = [];
  @Input() hasDateRangeFilter: boolean = false;
  @Input() singleDates: boolean = false;
  @Input() tableLoading: boolean = false;
  @Input() rowActions! : RowActions[];
  @Input() rowActionKeyName?: string;
  @Input() customSelectionRows: CustomSelection[] = [];
  @Input() selectionModel!: SelectionModel<any>;
  @Input() hasSort: boolean = false;
  @Input() totalObject!: TotalObject;
  @Input() serviceInstance!: BaseRequestService;
  @Input() reportSaveName?: string;
  @Input() emptyDataMessage?= "No Data!";
  @Input() ExtpendableColumn: string = '';
  @Input() columnNameToClick: string = '';
  @Input() LinkingCoulmns: object = {};
  @Input() isClickable: boolean = false;
  @Input() identifierKey?: string;
  @Input() hasCancelRequest: boolean = false;
  @Input() tableName!: string;
  @Input() showReportName=true;
  @Input() showTopBar = true;

  subscriptons: Subscription[] = [];
  initilised = false;
  tableComponentReference: any;
  tableComponentFactory: any;

  constructor(protected CFR: ComponentFactoryResolver) { }

  ngOnInit(): void {
  }

  ngOnChanges() {
    if (this.data && !this.initilised) {
      this.initReport();
    }
  }

  ngOnDestroy() {
    this.subscriptons.forEach(subs => subs.unsubscribe());
  }

  appendFilter(value: any): void {
    console.log('appendFilter value', value);
    this.filterTrigger.emit(value);
  }

  assignedBusinessesChanged(value: boolean): void {
    this.assignedBusinessesFilterChanged.emit(value);
  }

  searchChanges(value: any) {
    this.searchChange.emit(value);
  }

  toggleFilters(value: any) {
    this.filterOpened.next(value);
  }

  paginationEvents(value: any) {
    this.paginationChange.emit(value);
  }

  selectionActionClicks(value: any) {
    this.selectionActionTrigger.emit(value);
  }

  rowActionClickedIn(value: any) {
    this.rowActionClicked.emit(value);
  }

  sortClicks(value: any) {
    this.sortTrigger.emit(value);
  }

  extpendableRowClick(value: any) {
    this.ExtpendableRowClicke.emit(value);
  }

  extpendableColumnClicks(value: any) {
    this.ExtpendableColumnClick.emit(value);
  }

  public initReport() {
    this.initilised = true;
  }
}
